// extracted by mini-css-extract-plugin
export default {"view":"app-components-View-View-module__PR6YPIgEsSXUOYUlNMTO","loadbar":"app-components-View-View-module__xBJ0BeA50uoKMItc7GPr"};